import React from 'react'
import SynthesisPonyfillManager from './SynthesisPonyfillManager'
import RecognitionManager from './RecognitionManager'

interface SpeechManagerProps {
  isRetorikNews?: boolean
}

const SpeechManager = ({ isRetorikNews }: SpeechManagerProps): JSX.Element => {
  return (
    <React.Fragment>
      <SynthesisPonyfillManager isRetorikNews={isRetorikNews} />
      {!isRetorikNews && <RecognitionManager />}
    </React.Fragment>
  )
}

export default SpeechManager
